var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2065.98 1399.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#91b3fa;}.cls-4{fill:#dce5fe;}.cls-5{fill:#bdd0fb;}.cls-6{fill:#2b69b3;}.cls-7{fill:#7d97f4;}.cls-8{fill:#18174a;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13,.cls-18,.cls-20,.cls-25{fill:#fff;}.cls-13{opacity:0.5;}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{opacity:0.16;}.cls-19{opacity:0.68;}.cls-20{mix-blend-mode:soft-light;}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{opacity:0.64;}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{fill:url(#linear-gradient-15);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -80.07,
    y1: 1555.64,
    x2: 1852.52,
    y2: 152.21,
    gradientTransform: "matrix(1.11, -0.01, 0.01, 1.1, -83.93, -175.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1204.31,
    y1: 243.82,
    x2: 1288.05,
    y2: 243.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1158.72,
    y1: 548.62,
    x2: 1182.33,
    y2: 548.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1206.84,
    y1: 547.87,
    x2: 1233.78,
    y2: 547.87,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1217.62,
    y1: 652.73,
    x2: 1220.62,
    y2: 491.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 725.78,
    y1: 1042.67,
    x2: 816.63,
    y2: 1042.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 794.52,
    y1: 1074.02,
    x2: 838.74,
    y2: 1074.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 724.01,
    y1: 988.09,
    x2: 767.34,
    y2: 988.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1023,
    y1: 320.39,
    x2: 961.2,
    y2: 492.18,
    gradientTransform: "matrix(0.04, 1, -1, 0.04, 1343.14, -625.45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 760.03,
    y1: 292.94,
    x2: 813.21,
    y2: 483.65,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 748.29,
    y1: 360.05,
    x2: 810.07,
    y2: 360.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 856.18,
    y1: 606.13,
    x2: 1067.85,
    y2: 606.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 613.15,
    y1: 1101.09,
    x2: 629.1,
    y2: 1101.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 693.76,
    y1: 1094,
    x2: 709.62,
    y2: 1094,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 760.55,
    y1: 757.57,
    x2: 581.96,
    y2: 930.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 782.42,
    y1: 507.45,
    x2: 750.15,
    y2: 685.94,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 799.91,
    y1: 629.41,
    x2: 858.88,
    y2: 629.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 745.66,
    y1: 613.57,
    x2: 713.38,
    y2: 919.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 933.44,
    y1: 642.27,
    x2: 806.02,
    y2: 800.78,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 957.59,
    y1: 661.69,
    x2: 830.18,
    y2: 820.2,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 756.7,
    y1: 570.04,
    x2: 713.2,
    y2: 720.03,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 265.65,
    y1: 3510.32,
    x2: 211.12,
    y2: 3582.46,
    gradientTransform: "translate(-1490.23 -2126.48) rotate(-35.22)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 185.78,
    y1: 3567.45,
    x2: 229.52,
    y2: 3522.57,
    gradientTransform: "translate(-1490.23 -2126.48) rotate(-35.22)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1108.03,
    y1: 825.48,
    x2: 1319.7,
    y2: 825.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1218.78,
    y1: 893.92,
    x2: 1207.78,
    y2: 731.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1218.02,
    y1: 646.22,
    x2: 1213.52,
    y2: 760.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1439.96,
    y1: 1020.63,
    x2: 1286.97,
    y2: 788.14,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1423.57,
    y1: 1031.42,
    x2: 1270.57,
    y2: 798.93,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1417.05,
    y1: 1462.08,
    x2: 1455.13,
    y2: 1017,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1493.65,
    y1: 1468.71,
    x2: 1531.74,
    y2: 1023.5,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1350.81,
    y1: 1114.89,
    x2: 1235.82,
    y2: 1275.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1421.67,
    y1: 958.31,
    x2: 1418.67,
    y2: 1171.29,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1436.63,
    y1: 1026.96,
    x2: 1240.15,
    y2: 852.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1443.66,
    y1: 1019.03,
    x2: 1247.17,
    y2: 845.04,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -5794.18,
    y1: -1246.06,
    x2: -5813.68,
    y2: -1186.07,
    gradientTransform: "matrix(0.97, 0.26, -0.26, 0.97, 8517.53, 825.37)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -5776.7,
    y1: -1240.39,
    x2: -5796.2,
    y2: -1180.39,
    gradientTransform: "matrix(0.97, 0.26, -0.26, 0.97, 8517.53, 825.37)",
    xlinkHref: "#linear-gradient-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2058.75,594.89c22.24-82.29-7.84-177-76.36-230.65-23.09-18.08-49.79-31.75-71.3-51.58-51.51-47.5-34.65-112.87-75.35-163.08-133-164-335-180.93-506.43-109.61-134.06,55.77-276.74,64.75-421.95,41.42C797.13,63.68,690.45,26.29,579.18,16.48,491.64,8.75,396.69,18,333.32,82.67c-28.48,29.05-52.89,62.65-87.08,85.16-41.11,27.06-93,35.75-133.23,64C62.7,267.17,37.69,329.36,36.37,389.61S54.6,508.73,78.86,564.17c21.69,49.54,47.8,99.44,48.47,153.28,1,75.49-47.56,141.69-85.51,207.61-47.57,82.64-59.65,156.46-9.41,237.79,42.37,68.58,95.58,117.37,180.88,129.33,178.28,25,341.56-40.39,516.6-59,156.26-16.62,312.14,11.58,465.83,35.85,180.88,28.57,421.26,55.76,582.51-52.49,56.7-38.06,99-95.9,117.35-160.41,15.11-53.18,14.21-109.31,23.57-163.72a444.23,444.23,0,0,1,61.21-159.91c23.1-36.91,51.81-70.86,69-110.68A201,201,0,0,0,2058.75,594.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.11,24.26c-25.81,134.28-150.88,916.55,410.95,1038,0,0,187.61-516.88-395.61-1047.36C339.35,10.25,330.8,15.49,329.11,24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.72,133.79c5.55,38.38,11.8,76.69,18.35,114.93s13.51,76.42,20.86,114.52q22,114.31,49.26,227.48,13.88,56.5,29.37,112.58c10.53,37.32,21.7,74.45,33.79,111.28,12.25,36.76,25.49,73.2,40.25,109s31.09,70.92,50.6,104.22a3.78,3.78,0,0,1-6.52,3.83v0c-19.6-33.83-35.82-69.35-50.56-105.36S532.32,853.54,520.2,816.6c-12-37-23-74.27-33.35-111.71S467.05,629.75,458,592Q431,478.62,409.71,364.05,399,306.79,389.37,249.35C383,211,376.93,172.7,371.55,134.22a1.6,1.6,0,0,1,3.17-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.59,523.51c-.17-7.27,9.54-9.94,13.08-3.59,34.24,61.34,129.06,219.36,233.6,290.2,170.22,115.35,317.48,333.65,261,478.59C644.25,1288.71,155.06,1315,136.59,523.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.78,613.63c.57,1.49,1.41,3.38,2.16,5.12l2.37,5.29,4.87,10.55,9.93,21q10.09,20.94,20.67,41.64,21,41.47,43.5,82.17c30.19,54.12,61.72,107.49,96.09,159,17.3,25.67,34.67,51.3,53.12,76.16s37.45,49.27,57.4,72.92c39.7,47.43,83,91.94,130.92,131.21a1.52,1.52,0,0,1,.24,2.14,1.54,1.54,0,0,1-2.1.26,797.82,797.82,0,0,1-71.1-60.46c-22.46-21.59-43.62-44.47-64.17-67.86a1479.36,1479.36,0,0,1-112-149.31c-17.16-25.94-33.47-52.44-49.39-79.15s-31.22-53.79-45.74-81.28-28.73-55.14-42.11-83.19q-10-21.06-19.54-42.33c-3.15-7.1-6.3-14.2-9.34-21.36l-4.48-10.76L173.93,620c-.7-1.86-1.42-3.52-2.12-5.7a1.51,1.51,0,0,1,2.84-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.6,1176.56H680.41v-51.81H342.6C349.83,1124.75,349.83,1176.56,342.6,1176.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M680.41,1163.6v-23.72a15,15,0,0,0-14.91-15.13H344c-6.48,0-11.73-4-11.73-9,0-1.51,1.6-2.74,3.57-2.74H687.21c8.06,0,20.85,9.71,20.85,21.69v33.11c0,11.29-12.42,20.45-20,20.45H337.71c-3,0-5.41-1.86-5.41-4.15,0-4.18,4.43-7.57,9.88-7.57H667.64A12.87,12.87,0,0,0,680.41,1163.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671,1136.33H354.3a1,1,0,0,1,0-1.9H671a.95.95,0,1,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671,1144H354.3a1,1,0,1,1,0-1.9H671a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671,1151.71H354.3a1,1,0,1,1,0-1.9H671a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671,1159.4H354.3a1,1,0,1,1,0-1.9H671a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671,1167.09H354.3a1,1,0,0,1,0-1.9H671a.95.95,0,1,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M713.72,1193.91v17.45c0,3-1.75,5.84-4.78,7.8l-3,1.93c-2.46,1.59-2,4.55,1,5.61h0c1.94.7,2.3,2.64.69,3.71l-3.78,2.51a3.51,3.51,0,0,0,0,6.19l2.71,1.81c2.34,1.57,2.28,4.32-.14,5.82l-2.92,1.81c-2,1.26-2.36,3.48-.76,5l1.6,1.57a5.53,5.53,0,0,1,1.78,3.93v27.55H310.63v-94.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.33,1214.11H699.86c.81,0,1.48-.49,1.48-1.11s-.67-1.1-1.48-1.1H324.33c-.82,0-1.48.49-1.48,1.1S323.51,1214.11,324.33,1214.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.33,1230.54H691c.82,0,1.48-.49,1.48-1.1s-.66-1.11-1.48-1.11H324.33c-.82,0-1.48.5-1.48,1.11S323.51,1230.54,324.33,1230.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.33,1242.64H686.41c.82,0,1.48-.49,1.48-1.11s-.66-1.1-1.48-1.1H324.33c-.82,0-1.48.49-1.48,1.1S323.51,1242.64,324.33,1242.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.46,1186.23H722.37c3.19,0,6,1.74,6.34,4.11.35,2.72-2.5,5-6.08,5H334.19c-6.82,0-12.71,3.56-14.13,8.54-6.35,22.31-5.87,45.54.11,69.5,1.39,5.56,7.91,9.59,15.48,9.59h379c3.2,0,6,1.74,6.35,4.11.35,2.72-2.51,5-6.08,5H306.23c-9.77,0-18.19-5.2-19.93-12.38-7.06-29.07-7.68-57,0-83.38,1.72-5.92,8.81-10.11,16.93-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1660.36,314.16c26.11,95.62,155.36,658.27-350.84,874.4,0,0-180.44-348.51,336.76-878.07A8.39,8.39,0,0,1,1660.36,314.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1624.17,406.93c-4.24,31.4-9.13,62.68-14.28,93.92s-10.71,62.42-16.6,93.54c-11.8,62.22-25,124.19-40.06,185.73s-32.06,122.64-52.31,182.74q-15,45.12-33.41,89.09c-12.29,29.26-25.76,58.1-41.5,85.79a3.41,3.41,0,0,1-5.93-3.37v0h0c15.7-27.28,29.22-55.83,41.59-84.85s23.56-58.59,33.7-88.51c20.49-59.79,37.7-120.7,53.13-182s28.86-123.19,41-185.29q9.08-46.59,17.06-93.37c5.32-31.18,10.37-62.43,14.76-93.74h0a1.44,1.44,0,0,1,2.86.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1443.1,1284.62s-12.39-113.56,86.71-243.06c91.94-120.15,319.94-400.11,362.12-544.16,1.87-6.38,11.06-5.77,12,.82,9.94,70.63,20.93,249.49-78.32,441.65C1697.62,1187.67,1443.1,1284.62,1443.1,1284.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1867.17,629.39c0,15.78-2,31.51-4.78,47-.34,1.94-.65,3.9-1,5.83l-1.24,5.79-2.48,11.59-3,11.47c-1,3.81-1.88,7.68-3.14,11.43A558.09,558.09,0,0,1,1817,810.74c-3.22,7.24-7.18,14.09-10.87,21.08l-5.61,10.45c-1,1.73-1.82,3.51-2.86,5.19l-3.06,5.08-12.23,20.33c-2,3.44-4.28,6.65-6.47,9.94l-6.64,9.83-6.63,9.83-3.34,4.9-3.55,4.75-14.22,19c-2.4,3.15-4.7,6.38-7.17,9.45l-7.4,9.21-14.81,18.44-15,18.27c-5,6.07-10,12.19-15.1,18.19q-15.21,18.11-30.7,36c-10.27,12-20.72,23.74-31.12,35.58l-31.54,35.19c-21,23.44-42.13,46.82-62.39,70.85-5.15,5.94-10,12.12-14.94,18.22-2.51,3-4.81,6.2-7.18,9.33s-4.77,6.23-7,9.43c-4.4,6.49-9.05,12.83-13,19.61l-3.08,5c-.5.84-1,1.66-1.51,2.52l-1.36,2.6-5.46,10.42,0,0a.88.88,0,0,1-1.16.36.87.87,0,0,1-.38-1.11,279.08,279.08,0,0,1,23.48-41.17c2.22-3.28,4.59-6.43,6.87-9.66s4.57-6.45,7-9.54c4.83-6.24,9.57-12.57,14.59-18.65l7.45-9.2c2.51-3,5.08-6,7.62-9l7.64-9,7.72-8.95c10.28-12,20.69-23.76,31.05-35.63,20.73-23.71,41.46-47.39,61.93-71.3s40.6-48.08,60.51-72.44l14.76-18.41,7.39-9.2c2.46-3.06,4.76-6.23,7.15-9.35l14.2-18.75,3.55-4.69,3.33-4.84,6.64-9.72c18-25.68,33.82-52.85,48.19-80.71a555.37,555.37,0,0,0,36-86.84c1.32-3.7,2.24-7.52,3.4-11.27L1855,699l2.84-11.43,1.41-5.72c.43-1.92.8-3.85,1.2-5.77.76-3.85,1.64-7.69,2.3-11.56l1.89-11.63a230.72,230.72,0,0,0,2.3-23.47.1.1,0,0,1,.1-.11A.11.11,0,0,1,1867.17,629.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M636.15,59.39l733,8.07c40.52.45,72.3,35.41,72.27,79.33l-.65,1086.57c0,30.4-24.63,55.61-54.31,55.74l-785.85,3.47c-27.73.12-50.48-23.07-50.48-51.54v-1089C550.13,100.47,588.64,58.87,636.15,59.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1308,163.55H691.9A46.79,46.79,0,0,0,645.3,210v896.76c0,25.17,20.76,44.68,46.6,44.68H1308c25.84,0,47-19.51,47-44.68V210C1355,184.85,1333.88,163.55,1308,163.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 907.41,
    y: 941.78,
    width: 190.51,
    height: 190.5,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1030.85,997.56c0,15.48-12.55,32.2-28,32.2s-28-16.72-28-32.2,12.55-26.47,28-26.47S1030.85,982.08,1030.85,997.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M968,1089.37h68.44a16.57,16.57,0,0,0,15.78-11.51l3.68-11.51a16.56,16.56,0,0,0-10-20.6c-27.85-10.18-56.65-8.87-86.15.94a16.5,16.5,0,0,0-10.58,20l2.84,10.46A16.57,16.57,0,0,0,968,1089.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 705.78,
    y: 202.28,
    width: 593.6,
    height: 62.87,
    rx: 20.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1287.81,237.47c2.06-16.44-9.36-31.4-25.5-33.43s-30.9,9.67-33,26.1a30.19,30.19,0,0,0,6.57,22.93l-30.05,23.11a4.19,4.19,0,0,0-.43,6.13l.28.29a3.88,3.88,0,0,0,5.51.15l27.3-26.88a29,29,0,0,0,16.32,7.7C1271,265.59,1285.75,253.91,1287.81,237.47Zm-32,18.14A22,22,0,1,1,1280,236.49,21.77,21.77,0,0,1,1255.85,255.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1124.12,
    y: 504.72,
    width: 190.51,
    height: 190.51,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1158.72,
    y: 542.87,
    width: 23.61,
    height: 11.5,
    rx: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1229.85,541.36h-18.47l-4.54,13h26.94ZM1214,544.15h13.13l2.8,9.25h-19.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1149.24,
    y: 550.54,
    width: 138.82,
    height: 94.43,
    rx: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1218.24,
    cy: 597.75,
    r: 27.04,
    transform: "translate(-136.02 511.7) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1218.65,
    cy: 597.75,
    r: 22.4,
    transform: "translate(-135.99 511.86) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1158.72,
    y: 560.43,
    width: 17.55,
    height: 3.63,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1258.67,558.61h16.8a.37.37,0,0,1,.37.37v2.88a.37.37,0,0,1-.37.37h-16.8a.38.38,0,0,1-.37-.37V559a.38.38,0,0,1,.38-.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 678.02,
    y: 939.3,
    width: 190.51,
    height: 190.51,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M725.78,1006.36c7.21,52.26,33.89,76.74,70,87.78l20.85-16.76c-38-15.37-64.64-42.67-76-86.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M794.52,1093.74c22,3.61,24.6,3.82,42.58-8.11a3.66,3.66,0,0,0,.38-5.82l-31.78-27.09a2.45,2.45,0,0,0-3.82.85l-5.24,11.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M725,1007.64c-2.17-20.09-1.8-23.12,10.62-39.84a3.66,3.66,0,0,1,5.83-.06l25.36,33.18a2.45,2.45,0,0,1-1.06,3.77L754,1009.31l-26.42.54A2.48,2.48,0,0,1,725,1007.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 900.97,
    y: 292.27,
    width: 190.51,
    height: 190.5,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 998.33,
    cy: 388.98,
    rx: 78.09,
    ry: 84.29,
    transform: "translate(565.93 1369.29) rotate(-87.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 993.77,
    cy: 383.35,
    rx: 66.14,
    ry: 62.48
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1020.2,389.36c0,6.9-.26,13.79-.8,20.67s-1.42,13.73-2.65,20.53a121.05,121.05,0,0,1-5.27,20,47.46,47.46,0,0,1-4.58,9.36,19,19,0,0,1-3.45,4,10.19,10.19,0,0,1-2.28,1.46,7,7,0,0,1-2.67.62,6.74,6.74,0,0,1-2.7-.49,9.55,9.55,0,0,1-2.33-1.38,17.55,17.55,0,0,1-3.52-3.94,45.4,45.4,0,0,1-4.65-9.33,118.68,118.68,0,0,1-5.33-20,240.91,240.91,0,0,1-3.64-41.19c0-6.9.31-13.79.84-20.67s1.32-13.73,2.48-20.54a122,122,0,0,1,5-20.08,45,45,0,0,1,4.46-9.38,17,17,0,0,1,3.44-3.95,8.69,8.69,0,0,1,2.28-1.35,6.36,6.36,0,0,1,2.62-.46,7.05,7.05,0,0,1,2.6.6,10,10,0,0,1,2.25,1.39,19.3,19.3,0,0,1,3.51,3.88,47,47,0,0,1,4.81,9.19,116.11,116.11,0,0,1,5.72,19.89,196.62,196.62,0,0,1,2.94,20.49C1019.87,375.56,1020.17,382.46,1020.2,389.36Zm-1.7,0c0-6.85-.23-13.71-.79-20.54a196.78,196.78,0,0,0-2.62-20.38,113.51,113.51,0,0,0-5.3-19.81,45.81,45.81,0,0,0-4.56-9.13,18.9,18.9,0,0,0-3.32-3.81,7.54,7.54,0,0,0-4.49-1.94,6.83,6.83,0,0,0-4.52,1.77,16.75,16.75,0,0,0-3.24,3.86,44.69,44.69,0,0,0-4.2,9.29,120.77,120.77,0,0,0-4.58,20,266.57,266.57,0,0,0-2.6,41,238.88,238.88,0,0,0,3.09,40.95,118.37,118.37,0,0,0,5,19.86,44.74,44.74,0,0,0,4.42,9.16,16.64,16.64,0,0,0,3.27,3.76,6.77,6.77,0,0,0,4.41,1.72,6.09,6.09,0,0,0,2.31-.57,9,9,0,0,0,2-1.35,18,18,0,0,0,3.21-3.83,46,46,0,0,0,4.34-9.19,118.7,118.7,0,0,0,5-19.88c1.15-6.75,1.91-13.57,2.42-20.41S1018.5,396.21,1018.5,389.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1055,389.36a100.56,100.56,0,0,1-3.6,26.39,84.74,84.74,0,0,1-11.11,24.17,64.38,64.38,0,0,1-18.88,18.64,49.93,49.93,0,0,1-12.12,5.53A45.55,45.55,0,0,1,996.11,466a48.16,48.16,0,0,1-25.32-7.44A64.24,64.24,0,0,1,951.86,440a85.14,85.14,0,0,1-11.16-24.19,95.59,95.59,0,0,1-2.7-13.09A97.56,97.56,0,0,1,938,376a95.65,95.65,0,0,1,2.72-13.09,84.77,84.77,0,0,1,11.19-24.16,64.19,64.19,0,0,1,18.92-18.58,46.58,46.58,0,0,1,50.51,0,63.93,63.93,0,0,1,18.87,18.59A84.92,84.92,0,0,1,1051.36,363,99,99,0,0,1,1055,389.36Zm-1.94,0a103.8,103.8,0,0,0-.85-13.07,96.93,96.93,0,0,0-2.52-12.85,84.16,84.16,0,0,0-10.53-23.9A62.68,62.68,0,0,0,1020.9,321a49,49,0,0,0-11.86-5.51,43.42,43.42,0,0,0-25.86,0A48.66,48.66,0,0,0,971.33,321a62.4,62.4,0,0,0-18.19,18.6,84.06,84.06,0,0,0-10.49,23.88,98.39,98.39,0,0,0-2.51,12.84,103.48,103.48,0,0,0-.84,13.05,101.78,101.78,0,0,0,.86,13.05,96.5,96.5,0,0,0,2.52,12.82,83.9,83.9,0,0,0,10.51,23.86,62.5,62.5,0,0,0,18.19,18.56,48.83,48.83,0,0,0,11.83,5.51,43,43,0,0,0,25.79,0,48.5,48.5,0,0,0,11.85-5.48,62.51,62.51,0,0,0,18.25-18.54,84.19,84.19,0,0,0,10.55-23.87A99,99,0,0,0,1053.05,389.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M927.85,359c5.85-.11,11.71-.16,17.56-.24l17.57-.13c5.86-.06,11.71-.05,17.57-.07l17.56,0,17.57,0c5.86,0,11.71,0,17.57.08l17.57.14c5.85.09,11.71.14,17.56.26a.09.09,0,0,1,.09.09.09.09,0,0,1-.09.08c-5.85.12-11.71.17-17.56.26l-17.57.14c-5.86.06-11.71.05-17.57.08l-17.57,0-17.56,0c-5.86,0-11.71,0-17.57-.07l-17.57-.13c-5.85-.08-11.71-.13-17.56-.24a.13.13,0,0,1-.13-.13A.12.12,0,0,1,927.85,359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M948.23,329.61c4.15-.11,8.31-.15,12.47-.23l12.47-.14c8.32-.09,16.63-.1,24.94-.11s16.63,0,24.95.12l12.47.15c4.16.09,8.32.14,12.47.26a.09.09,0,0,1,.09.08.09.09,0,0,1-.09.09c-4.15.11-8.31.17-12.47.25l-12.47.15c-8.32.09-16.63.11-24.95.12s-16.62,0-24.94-.11l-12.47-.13c-4.16-.08-8.32-.13-12.47-.24a.13.13,0,0,1-.13-.13A.14.14,0,0,1,948.23,329.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M921.74,388.46c6.37-.11,12.73-.16,19.09-.24l19.1-.13c6.36-.06,12.73,0,19.09-.07l19.09,0,19.1,0c6.36,0,12.73,0,19.09.07l19.1.15c6.36.08,12.72.13,19.09.25a.08.08,0,0,1,.08.09.08.08,0,0,1-.08.08c-6.37.12-12.73.17-19.09.26l-19.1.15c-6.36.06-12.73,0-19.09.07l-19.1.05-19.09,0c-6.36,0-12.73,0-19.09-.07l-19.1-.14c-6.36-.08-12.72-.12-19.09-.23a.12.12,0,0,1-.12-.13A.12.12,0,0,1,921.74,388.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M927.85,417.88c5.85-.11,11.71-.15,17.56-.23l17.57-.14c5.86-.05,11.71-.05,17.57-.06l17.56,0,17.57,0c5.86,0,11.71,0,17.57.07l17.57.15c5.85.09,11.71.14,17.56.26a.09.09,0,0,1,.09.08.09.09,0,0,1-.09.09c-5.85.12-11.71.17-17.56.25l-17.57.15c-5.86.06-11.71.05-17.57.07l-17.57.05-17.56,0c-5.86,0-11.71,0-17.57-.07l-17.57-.13c-5.85-.08-11.71-.13-17.56-.24a.13.13,0,0,1-.13-.13A.14.14,0,0,1,927.85,417.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1050.52,447.89H950.74a.45.45,0,0,1-.45-.45.45.45,0,0,1,.45-.45h99.78a.45.45,0,0,1,.45.45A.45.45,0,0,1,1050.52,447.89Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 683.06,
    y: 291.8,
    width: 190.51,
    height: 190.5,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 779.02,
    cy: 360.21,
    r: 50.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M829.59,357.5H728.35s-4,28.12,41.19,105.15a11.06,11.06,0,0,0,19,0C833.71,385.65,829.59,357.5,829.59,357.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M779,469.66V470h0a12.55,12.55,0,0,1-10.74-6.21c-26.43-45-36.12-73.49-39.59-89.42a51.18,51.18,0,0,1-1.74-10.94,25.47,25.47,0,0,1,0-5.52l.13-.81a52.14,52.14,0,0,1,104,.51,22.85,22.85,0,0,1,.08,2.8v.18a52.4,52.4,0,0,1-2.09,14.65c-3.59,15.92-13.34,44.11-39.32,88.37A12.28,12.28,0,0,1,779,469.66ZM729.73,359.77a34.73,34.73,0,0,0,.15,3.48h0a47.83,47.83,0,0,0,1.65,10.32l0,.06c3.42,15.72,13,43.83,39.26,88.55a9.51,9.51,0,0,0,8.19,4.67v0a10,10,0,0,0,8.22-4.71c25.82-44,35.46-71.93,39-87.64l0-.09a49.29,49.29,0,0,0,1.69-13.87l-.3-.2v0a18.14,18.14,0,0,1,.23-2.47l.14-.08a49.13,49.13,0,0,0-98.12.51l0,1.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 779.18,
    cy: 360.05,
    r: 29.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M779.18,390.94a30.89,30.89,0,1,1,30.89-30.89A30.93,30.93,0,0,1,779.18,390.94Zm0-58.51a27.62,27.62,0,1,0,27.62,27.62A27.65,27.65,0,0,0,779.18,332.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M751.43,329.59a.49.49,0,0,1-.32-.86,45.4,45.4,0,0,1,29.57-11,.49.49,0,0,1,0,1,44.39,44.39,0,0,0-28.93,10.71A.49.49,0,0,1,751.43,329.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M735.76,363.67a.48.48,0,0,1-.49-.49,45.35,45.35,0,0,1,6.79-23.9.49.49,0,0,1,.84.52,44.29,44.29,0,0,0-6.65,23.38A.48.48,0,0,1,735.76,363.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1229.49,1166.21h474.14v-77H1229.49C1239.63,1089.2,1239.63,1166.21,1229.49,1166.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1703.63,1146.94v-35.25c0-12.42-9.37-22.49-20.93-22.49H1231.49c-9.09,0-16.46-6-16.46-13.36,0-2.24,2.24-4,5-4h493.14c11.31,0,29.27,14.42,29.27,32.22v49.22c0,16.78-17.43,30.39-28.1,30.39H1222.62c-4.19,0-7.59-2.76-7.59-6.16,0-6.22,6.2-11.25,13.86-11.25H1685.7C1695.6,1166.21,1703.63,1157.58,1703.63,1146.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1690.48,1106H1245.91a1,1,0,1,1,0-1.9h444.57a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1690.48,1117.38H1245.91a1,1,0,1,1,0-1.9h444.57a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1690.48,1128.81H1245.91a1,1,0,1,1,0-1.9h444.57a.95.95,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1690.48,1140.24H1245.91a1,1,0,1,1,0-1.9h444.57a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1690.48,1151.67H1245.91a1,1,0,1,1,0-1.9h444.57a1,1,0,0,1,0,1.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1085.91,
    y: 1182.8,
    width: 632.8,
    height: 128.67,
    rx: 21.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1157.42,
    y: 1197.59,
    width: 74.34,
    height: 99.1,
    rx: 7.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1242.7,
    y: 1197.59,
    width: 27.89,
    height: 99.1,
    rx: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 856.18,
    y: 500.3,
    width: 211.67,
    height: 211.67,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1006.07,665.53a.95.95,0,0,1-.54-1.73c.65-.44,1.29-.9,1.92-1.36a1,1,0,0,1,1.33.21,1,1,0,0,1-.21,1.33c-.64.47-1.3.94-2,1.39A1,1,0,0,1,1006.07,665.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M965.22,678.12c-1.2,0-2.42,0-3.62-.09a1,1,0,0,1-.9-1,.92.92,0,0,1,1-.9c1.55.07,3.1.1,4.64.07h0a1,1,0,0,1,0,1.91Zm5.81-.24A1,1,0,0,1,971,676c1.53-.12,3.08-.3,4.6-.52a.94.94,0,0,1,1.08.8,1,1,0,0,1-.8,1.08c-1.57.23-3.16.41-4.73.54ZM957,677.64h-.11c-1.58-.18-3.16-.41-4.71-.7a1,1,0,1,1,.34-1.87c1.51.28,3,.51,4.58.68a1,1,0,0,1-.1,1.9Zm23.35-1.12a1,1,0,0,1-.93-.76.94.94,0,0,1,.73-1.12c1.5-.32,3-.7,4.5-1.12a1,1,0,0,1,.52,1.84c-1.53.43-3.09.81-4.62,1.14ZM947.73,676l-.23,0c-1.53-.38-3.07-.82-4.57-1.3a1,1,0,1,1,.58-1.82c1.46.47,3,.9,4.45,1.27a1,1,0,0,1,.69,1.16A.94.94,0,0,1,947.73,676Zm41.62-2a1,1,0,0,1-.31-1.85c1.46-.51,2.91-1.08,4.32-1.68a1,1,0,0,1,1.25.5,1,1,0,0,1-.51,1.25c-1.44.62-2.93,1.2-4.43,1.72A.87.87,0,0,1,989.35,674Zm-50.56-.88a1.15,1.15,0,0,1-.35-.07c-1.46-.58-2.93-1.21-4.36-1.88a1,1,0,1,1,.81-1.72c1.39.65,2.82,1.27,4.25,1.83a1,1,0,0,1-.35,1.84Zm59.2-2.8a1,1,0,0,1-.43-1.8c1.38-.7,2.74-1.44,4.06-2.22a1,1,0,0,1,1.31.33,1,1,0,0,1-.34,1.31c-1.36.8-2.76,1.56-4.17,2.28A1,1,0,0,1,998,670.3Zm-67.69-1.19a1,1,0,0,1-.46-.12c-1.38-.76-2.76-1.58-4.09-2.43a1,1,0,0,1-.29-1.31,1,1,0,0,1,1.32-.29c1.29.83,2.63,1.62,4,2.36a1,1,0,0,1-.46,1.79Zm-7.91-5.05a1,1,0,0,1-.56-.18c-1.27-.93-2.53-1.92-3.75-2.94a1,1,0,0,1,1.23-1.45c1.18,1,2.4,2,3.64,2.85a1,1,0,0,1-.56,1.72Zm-7.19-6a1,1,0,0,1-.66-.26c-1.14-1.09-2.26-2.23-3.33-3.39a1,1,0,1,1,1.4-1.29c1,1.13,2.13,2.24,3.24,3.3a1,1,0,0,1,0,1.35A.94.94,0,0,1,915.2,658Zm-6.36-6.9a1,1,0,0,1-.74-.35c-1-1.23-2-2.5-2.86-3.79a1,1,0,0,1,1.56-1.1c.88,1.26,1.82,2.5,2.78,3.7a.94.94,0,0,1-.14,1.33A.9.9,0,0,1,908.84,651.14Zm-5.4-7.66a1,1,0,0,1-.81-.45c-.82-1.35-1.61-2.74-2.35-4.14A1,1,0,0,1,902,638c.71,1.36,1.48,2.71,2.28,4a.95.95,0,0,1-.81,1.44Zm-4.36-8.3a1,1,0,0,1-.87-.57c-.64-1.44-1.24-2.92-1.79-4.4A1,1,0,0,1,897,629a.94.94,0,0,1,1.22.56c.54,1.44,1.13,2.89,1.75,4.29a1,1,0,0,1-.48,1.26A1.09,1.09,0,0,1,899.08,635.18Zm-3.25-8.8a1,1,0,0,1-.92-.68c-.09-.33-.19-.65-.28-1-.34-1.2-.65-2.41-.93-3.62a.95.95,0,1,1,1.85-.42c.28,1.17.58,2.36.91,3.52.09.32.18.64.28,1a1,1,0,0,1-.64,1.18A.84.84,0,0,1,895.83,626.38Zm-2.11-9.14a1,1,0,0,1-.94-.8c-.25-1.57-.46-3.15-.61-4.72a.95.95,0,1,1,1.89-.18c.15,1.52.35,3.07.6,4.59a1,1,0,0,1-.79,1.09Zm-.91-9.34a1,1,0,0,1-.95-.93c0-.77,0-1.55,0-2.33s0-1.62,0-2.42a1,1,0,1,1,1.9.06c0,.79,0,1.57,0,2.36s0,1.52,0,2.27a.94.94,0,0,1-.92,1Zm.31-9.38H893a1,1,0,0,1-.85-1c.15-1.57.36-3.15.62-4.72a.94.94,0,0,1,1.09-.78,1,1,0,0,1,.79,1.09c-.26,1.53-.46,3.07-.61,4.6A1,1,0,0,1,893.12,598.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M894.66,589.22l-.21,0a1,1,0,0,1-.71-1.14c.18-.78.38-1.56.58-2.34a1,1,0,0,1,1.84.5c-.2.75-.39,1.51-.57,2.27A1,1,0,0,1,894.66,589.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M927.6,543.7a.95.95,0,0,1-.49-1.76c.68-.42,1.38-.83,2.08-1.22a1,1,0,0,1,.93,1.66c-.68.38-1.36.78-2,1.18A.87.87,0,0,1,927.6,543.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1036.19,620.52a.71.71,0,0,1-.2,0,1,1,0,0,1-.73-1.13c.33-1.56.61-3.15.83-4.74a1,1,0,0,1,1.89.26c-.23,1.63-.52,3.27-.86,4.88A1,1,0,0,1,1036.19,620.52Zm1.36-9.66h-.07a1,1,0,0,1-.88-1c.12-1.6.18-3.22.19-4.82a1,1,0,0,1,1-.95h0a1,1,0,0,1,1,1c0,1.64-.07,3.31-.19,4.94A1,1,0,0,1,1037.55,610.86Zm0-9.76a1,1,0,0,1-.94-.9c-.11-1.59-.26-3.2-.47-4.79a.95.95,0,1,1,1.88-.25c.22,1.63.38,3.29.48,4.92a.94.94,0,0,1-.88,1Zm-1.27-9.68a1,1,0,0,1-.94-.77c-.31-1.57-.68-3.14-1.1-4.69a1,1,0,0,1,.67-1.17.94.94,0,0,1,1.16.67c.43,1.59.82,3.21,1.14,4.82a1,1,0,0,1-.74,1.12Zm-2.56-9.42a1,1,0,0,1-.9-.64c-.52-1.52-1.1-3-1.72-4.51a1,1,0,0,1,1.76-.73c.63,1.51,1.22,3.06,1.76,4.62a1,1,0,0,1-.59,1.21A1.12,1.12,0,0,1,1033.76,582Zm-3.78-9a1,1,0,0,1-.86-.52c-.72-1.43-1.49-2.85-2.3-4.23a.95.95,0,1,1,1.63-1c.84,1.41,1.64,2.88,2.37,4.35a.94.94,0,0,1-.42,1.27A.92.92,0,0,1,1030,573Zm-5-8.39a.94.94,0,0,1-.78-.42c-.9-1.31-1.87-2.62-2.86-3.87a1,1,0,0,1,.16-1.34.93.93,0,0,1,1.33.16c1,1.29,2,2.63,2.94,4a1,1,0,0,1-.79,1.49Zm-6-7.66a.91.91,0,0,1-.7-.31c-1.08-1.18-2.21-2.34-3.36-3.45a1,1,0,1,1,1.32-1.37c1.18,1.14,2.34,2.33,3.44,3.54a1,1,0,0,1-.06,1.35A1,1,0,0,1,1019,557Zm-7-6.76a.94.94,0,0,1-.61-.22c-1.23-1-2.51-2-3.79-3a.95.95,0,1,1,1.12-1.53c1.32,1,2.63,2,3.89,3a1,1,0,0,1,.12,1.34A1,1,0,0,1,1011.93,550.19Zm-7.88-5.76a.91.91,0,0,1-.5-.15c-1.36-.86-2.76-1.68-4.16-2.44a1,1,0,1,1,.91-1.67c1.44.78,2.87,1.62,4.26,2.5a1,1,0,0,1-.51,1.76ZM934,540.25a1,1,0,0,1-.41-1.81c1.48-.71,3-1.37,4.53-2a1,1,0,0,1,1.24.54,1,1,0,0,1-.54,1.23c-1.49.59-3,1.24-4.41,1.93A1,1,0,0,1,934,540.25Zm61.49-.48a.93.93,0,0,1-.4-.09c-1.45-.67-3-1.29-4.44-1.86a1,1,0,0,1-.55-1.23.94.94,0,0,1,1.22-.55c1.54.58,3.07,1.23,4.56,1.91a1,1,0,0,1-.39,1.82Zm-52.42-3.12a1,1,0,0,1-.29-1.86c.81-.26,1.63-.5,2.45-.74s1.54-.42,2.31-.61a1,1,0,0,1,.46,1.85c-.75.18-1.5.38-2.25.59s-1.6.47-2.39.72A.71.71,0,0,1,943.06,536.65Zm43.3-.35a.86.86,0,0,1-.28,0c-1.53-.47-3.1-.89-4.66-1.25a1,1,0,0,1,.43-1.86c1.6.38,3.21.81,4.78,1.29a.93.93,0,0,1,.63,1.18A1,1,0,0,1,986.36,536.3Zm-33.83-2a1,1,0,0,1-.17-1.89c1.62-.29,3.27-.53,4.9-.71a1,1,0,0,1,1,.84.94.94,0,0,1-.84,1.05c-1.59.18-3.19.41-4.77.69Zm24.32-.21h-.16c-1.57-.26-3.18-.46-4.78-.61a1,1,0,1,1,.18-1.9c1.64.16,3.29.37,4.91.63a1,1,0,0,1,.78,1.1A.94.94,0,0,1,976.85,534.08Zm-14.62-.86a1,1,0,0,1,0-1.91c1.64-.07,3.31-.08,5,0a.94.94,0,0,1,.92,1,1,1,0,0,1-1,.92c-1.6,0-3.23,0-4.83,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1034.33,627.58a.93.93,0,0,1-.29-.05,1,1,0,0,1-.62-1.19c.24-.75.46-1.5.68-2.25a1,1,0,0,1,1.83.52c-.22.77-.45,1.54-.7,2.31A.94.94,0,0,1,1034.33,627.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1023.8,631.82a1,1,0,0,0-.09-1.17l-7.88-9.4a53.4,53.4,0,0,0,2.56-17.13l10.28-6.68a1,1,0,0,0,.43-1.09l-3.56-14.28a1,1,0,0,0-.89-.76l-12.22-1.08a53.36,53.36,0,0,0-10.31-13.91l2.55-12a1,1,0,0,0-.47-1.07l-12.62-7.58a1,1,0,0,0-1.17.09l-9.4,7.89a53.36,53.36,0,0,0-17.13-2.56L957.2,540.8a1,1,0,0,0-1.09-.43l-14.28,3.56a1,1,0,0,0-.76.89L940,557a53.24,53.24,0,0,0-13.92,10.31l-12-2.55a1,1,0,0,0-1.08.47l-7.57,12.62a1,1,0,0,0,.09,1.16l7.88,9.41a53.34,53.34,0,0,0-2.56,17.12l-10.28,6.69a1,1,0,0,0-.43,1.09l3.56,14.28a1,1,0,0,0,.89.76l12.22,1.07a53.41,53.41,0,0,0,10.31,13.92l-2.55,12a1,1,0,0,0,.47,1.07L937.65,664a1,1,0,0,0,1.17-.09l9.4-7.88a53.64,53.64,0,0,0,17.13,2.56L972,668.91a1,1,0,0,0,1.09.43l14.28-3.57a1,1,0,0,0,.76-.89l1.07-12.21a53.47,53.47,0,0,0,13.92-10.31l12,2.54a1,1,0,0,0,1.08-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M964.63,618.88A14,14,0,0,1,958,592.49a14,14,0,1,1,6.64,26.39Zm0-26.14a12.11,12.11,0,1,0,5.75,22.79,12.13,12.13,0,0,0,5-16.4A12.15,12.15,0,0,0,964.59,592.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M964.34,641.19a36.47,36.47,0,1,1,35.38-45.3h0a36.75,36.75,0,0,1,1,6.58c0,.37,0,.74,0,1.1v0a1,1,0,0,1-1.9,0,34.61,34.61,0,0,0-1-7.29v0h0a34.54,34.54,0,1,0-9.12,32.89,1,1,0,0,1,1.34,1.35,36.55,36.55,0,0,1-25.74,10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804,1399.87a5.28,5.28,0,0,1-5.34-4L714.24,948.89a4.93,4.93,0,0,1,4.45-5.59,5.4,5.4,0,0,1,6.25,4l84.43,446.94c.5,2.64-1.49,5.14-4.45,5.59A7,7,0,0,1,804,1399.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.17,1399.87a5.61,5.61,0,0,1-1.07-.1c-2.94-.53-4.84-3.09-4.25-5.71l99.53-441.12a5.42,5.42,0,0,1,6.39-3.8c2.94.53,4.84,3.09,4.25,5.71L524.49,1396A5.32,5.32,0,0,1,519.17,1399.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.59,1059.34H595.31a4.88,4.88,0,1,1,0-9.7H739.59a4.88,4.88,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M737,1059.34h-139a4.86,4.86,0,1,1,0-9.7H737a4.86,4.86,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.59,1140.15H595.31a4.88,4.88,0,1,1,0-9.7H739.59a4.88,4.88,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M752.69,1140.15H577.77a4.88,4.88,0,1,1,0-9.7H752.69a4.88,4.88,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.59,1221H595.31a4.88,4.88,0,1,1,0-9.7H739.59a4.88,4.88,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M769.4,1221H560a4.88,4.88,0,1,1,0-9.7H769.4a4.88,4.88,0,1,1,0,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.59,1301.77H543.18a4.88,4.88,0,1,1,0-9.69H739.59a5.16,5.16,0,0,1,5.43,4.85C745,1299.6,742.59,1301.77,739.59,1301.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M782.91,1301.77H543.18a4.88,4.88,0,1,1,0-9.69H782.91a5.16,5.16,0,0,1,5.43,4.85C788.34,1299.6,785.91,1301.77,782.91,1301.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M614.64,1105.51s-4.38,6.89-5.47,26.18a3.14,3.14,0,0,0,3.12,3.33h34.19a2,2,0,0,0,1.91-2.66c-2-5.92-8.06-20.38-21.57-28.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M613.15,1092.43l1.93,16.22a3.06,3.06,0,0,0,2.67,2.68,27.49,27.49,0,0,0,7.23-.07,5,5,0,0,0,4.12-5v-15.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M699.22,1103.72a47.75,47.75,0,0,0-6.4,24.13,6,6,0,0,0,6.08,5.91H752a2.54,2.54,0,0,0,1.46-4.63c-10-7.05-29.79-20.23-44.08-25.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M693.76,1086.21l4.12,20a4.12,4.12,0,0,0,4.88,3.25,14.81,14.81,0,0,0,4.67-2,4.74,4.74,0,0,0,2.12-4.84l-4.27-24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M620.73,807.79s-14.34,12.65-17,27.86,7.64,262.45,7.64,262.45,14.34,2.38,21.74-2.1c0,0,8.76-160.45,15.43-197.53,0,0,35,166.21,44.63,196.24,0,0,13.82,1.68,18.27-.94,0,0-9.15-215.46-20.65-253.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M648.08,893.22a1.52,1.52,0,0,1-1.47-1.14l-5.94-22.79L628,861.17a1.52,1.52,0,1,1,1.64-2.56l13.16,8.44a1.49,1.49,0,0,1,.65.9l6.09,23.36a1.51,1.51,0,0,1-1.08,1.86A1.74,1.74,0,0,1,648.08,893.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M762.25,664.93c-60.37-5-76.15,7.48-76.15,7.48l29,45.81s59.32-1.18,101.83-33.94a103.73,103.73,0,0,1-17-25.4A80,80,0,0,1,762.25,664.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M856.79,576.32a1.85,1.85,0,0,0-3.53-.71l-7.7,16.44a17.1,17.1,0,0,0-1.37,10.19l2.71,9.56A16.58,16.58,0,0,1,843.53,625c-7.08,8.85-22.16,25-43.62,33.93a103.73,103.73,0,0,0,17,25.4c15.59-12,28.93-28.29,36.23-50.32a8.08,8.08,0,0,0,5.71-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M782.12,691.49c-21.25-22.9-61.73-33.25-85.17-37.5a21.5,21.5,0,0,0-24,13.63c-10.55,28.36-39.23,102.12-44.79,114.8-4.57,10.4-9.33,20.56-12.36,26.91a7.64,7.64,0,0,0,3.56,10.16c19.72,9.5,55.2,20.26,69.59,24.45a4.93,4.93,0,0,0,6.31-4.75,15.39,15.39,0,0,1,2.2-7.93l54.48-90.79c34,37.65,63.7,41.09,86.54,32.85a172.11,172.11,0,0,1-7.56-35.68C797.14,731.86,782.12,691.49,782.12,691.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M886.67,731.32l-6.09-8.12c-19.72,13.55-36.2,16.76-49.69,14.44a172.11,172.11,0,0,0,7.56,35.68C868.55,762.47,886.67,731.32,886.67,731.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M882.38,731.47l34.31,1.34,31.59-17.65c-4.53-2.84-30.18,3-30.18,3s-26.81-4-34.06-4.06c-6,0-5.17,8.66-4.7,11.59.09.6.17,1,.17,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M729.19,611.93l-18.11,44.18s20.8,14.4,37.54,13l9-39.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M759.77,581.81c.41.59,13.09,46.41,13.09,46.41l-26.31,6.68-18.47-41.64S752.83,572,759.77,581.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M738,599.59l8,22.68a3.46,3.46,0,0,0,.42.81c1.09,1.55,5.22,6.59,10.11,2,4.45-4.12,8.56-7.81,12.36-8.48a3.37,3.37,0,0,1,3.83,2.41,144.91,144.91,0,0,1,4.42,22.1,3.36,3.36,0,0,1-2.72,3.62c-5.14,1-16,2.73-25.14,2.09a3.37,3.37,0,0,1-2.83-2c-2.51-5.48-10.19-22.1-13.05-26.4-2.68-4-9.25-3.93-12-3.68a3.29,3.29,0,0,1-2.47-.81c-2.41-2.12-7-7.51-.55-14a3.36,3.36,0,0,0-.08-4.84c-2.77-2.61-5.73-7.23-1.11-13s10.89-4.9,14.69-3.51a3.35,3.35,0,0,0,4-1.5,2.68,2.68,0,0,1,2.75-1.28,3.31,3.31,0,0,0,3.53-3.39c-.07-3.74,1.27-8.45,7.74-10.47,11.5-3.58,18.67,7.53,19.38,15.81s-12,11.46-19.43,10.9c-5.67-.42-9.89,5.2-11.58,7.92A3.33,3.33,0,0,0,738,599.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M736.39,626.74s-1.85-14.38-7.84-15.09-11.81,4.22-5.86,12.29C730.09,634,736.39,626.74,736.39,626.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1108.03,
    y: 719.65,
    width: 211.67,
    height: 211.67,
    rx: 28.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1276.5,881H1146.75a9.49,9.49,0,0,1-9.48-9.49V787a9.48,9.48,0,0,1,9-9.47L1281,770a9.48,9.48,0,0,1,10,10l-5,92A9.48,9.48,0,0,1,1276.5,881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1214.66,830l70.92-59.07a9.33,9.33,0,0,0-4.6-.9l-134.75,7.51a9.49,9.49,0,0,0-6,2.56l53.08,49.37A16.51,16.51,0,0,0,1214.66,830Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1204.8,827.06a14.86,14.86,0,0,1-9.86-3.75l-20-17.66a1.42,1.42,0,0,1,1.88-2.12l20,17.65a12,12,0,0,0,15,.75l10.36-7.44a1.42,1.42,0,0,1,1.66,2.3l-10.37,7.45A14.85,14.85,0,0,1,1204.8,827.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1168.44,799.44a1.4,1.4,0,0,1-.94-.36l-2.69-2.37a1.42,1.42,0,1,1,1.87-2.13l2.7,2.38a1.42,1.42,0,0,1,.12,2A1.4,1.4,0,0,1,1168.44,799.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1515.63,979.51c-7.38-27.26-30.15-49.66-55.52-55.31a8.56,8.56,0,0,1-6.27-10.44l0-.1c3.68-15.85-6.48-28.48-21.81-32s-30,3.32-33.68,19.17a35.09,35.09,0,0,0,7.73,30.52,8.53,8.53,0,0,1,.32,11.3c-15.46,18.12-21.75,45.77-15.06,70.5,9.85,36.42,44.1,52.7,78.41,43.42S1525.47,1015.93,1515.63,979.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1505,1014.27l-.66-.47c6.14-8.72,6.93-21.3,2-32.84-3.87-9.17-10.79-17.55-21.8-26.38-4.09-3.29-8.44-6.41-12.64-9.43-5.07-3.64-10.3-7.39-15.15-11.48-4.36-3.68-9-8.24-9.91-14.21a31.13,31.13,0,0,1,.4-9.21c.68-4.79,1.32-9.32-1.49-12.79l.63-.52c3,3.75,2.34,8.67,1.67,13.43a30.55,30.55,0,0,0-.41,9c.92,5.71,5.39,10.14,9.64,13.72,4.82,4.06,10,7.81,15.09,11.44,4.21,3,8.57,6.15,12.68,9.46,11.12,8.91,18.12,17.4,22,26.69C1512.08,992.44,1511.26,1005.32,1505,1014.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1488.64,1019.53l-.77-.27c4.18-11.57,3-25.77-3.36-39s-16.49-23.77-24.7-31.61l.56-.59c8.27,7.89,18.56,18.63,24.88,31.85C1491.66,993.33,1492.89,1007.77,1488.64,1019.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1324.08,870l-.28-9.41,9.84-19.54a12.71,12.71,0,0,0,0-11.37l-11.14-22.51s-6.44,48.85-8.13,52.91,4.59,11.36,4.59,11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1323.8,860.58s29.93,81.59,80.92,107.09c0,0-17,27.7-25.83,29.38,0,0-54.48-69.73-60-126.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1528.9,1351.38l1.5,12.38c1.57,5.88,9.14,20.69,18.86,19.73,6-.59,6.69-18.06,5.86-20.68-1.52-4.78-4.29-12-8.3-16.17H1533.1A4.23,4.23,0,0,0,1528.9,1351.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1421.39,1206.43l-2.32,13.63s7.76,78.59,9.14,110a24.66,24.66,0,0,1-3.65,14L1411.07,1366l34.29-20.23.68-4.19-5.61-7.72,7.35-88a27,27,0,0,0-3.07-14.94l-7.1-13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1408.81,1369.16h11a6.57,6.57,0,0,0,5.22-2.56c3.42-4.43,10.48-13.08,13.86-13.31,4.55-.3,4,15.87,4,15.87h2.55l3.23-20.09a11.9,11.9,0,0,0-6.24-12.44h0s-1,7.69-6.68,11.09-23,15.59-23,15.59a15.65,15.65,0,0,0-4.44.12A2.89,2.89,0,0,0,1408.81,1369.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1468.35,1212.9s45.45,86.22,52.68,105.91,9.75,36.1,9.85,37.66c.15,2.43,3.17,4.76,11.5,4.76,4.3,0,6.41-1.73,7.44-3.39a4.87,4.87,0,0,0,.18-4.71c-2.63-5.32-11-22.32-14.06-30-3.69-9.2-11.63-50.93-16-65.44s-9.27-30.25-28.22-44.75C1491.74,1212.9,1478.72,1200.16,1468.35,1212.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1439.64,1071.63c-6.66-28.21,0-49.46,7.07-62.56a21.14,21.14,0,0,0-8.86-28.85,164,164,0,0,0-33.13-12.55s-32.58,23.82-28.71,42.47c2.26,10.93,22.9,65.46,22.9,65.46S1418,1084.63,1439.64,1071.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1465.63,1096.23c-4.77-14.38-26-24.6-26-24.6-21.65,13-40.73,4-40.73,4s-4.28,16.35-1.33,31.56,21.49,112.9,21.49,112.9c29.2,5.91,74.11-6,74.11-6C1474.58,1181.08,1470.4,1110.6,1465.63,1096.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1426,934.84l9.53,42.82c.91,3.77-2.53,3.15-6.34,2.43-6.24-1.17-14.29-3.6-17-8.46a4.5,4.5,0,0,1-.49-1.61l-4.1-29.69a5.35,5.35,0,0,1,3.13-5.61l7.9-3.5A5.34,5.34,0,0,1,1426,934.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1306.88,906.56s25.09,87.16,126.26,79a11.73,11.73,0,0,1,12.66,10.75l.27,3.5a15.6,15.6,0,0,1-16.32,16.81c-33.64-1.7-105.91-14.92-130.68-94.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1299.07,921.71s-4.82-14.19-6-23.05,3.25-28.78,7.08-34.37,4.47,8.12,6.2,14.57-1.2,15.64-1.2,15.64l1.76,12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1406.48,899.52s-24.1,35.11-9.11,44.89,32.14-15.17,32.14-15.17,5.39-19.07-.74-25.39S1406.48,899.52,1406.48,899.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1416.59,891s-10.48,2.69-11.87,7.49,15.11,8.9,19.71,9l4.07,19.16s10.62-18.3,6.08-28.66S1416.59,891,1416.59,891Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1424.67,926.79s9.42-11.35,13.39-4.14-8.43,12.9-12.83,9.41Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg2);
export default __webpack_public_path__ + "static/media/about_img_2.bb685be52adb4b183ec38a3d9f1d0d32.svg";
export { ForwardRef as ReactComponent };